import * as types from "../ActionType";
import axios from "axios";
import { notifyError , notifysuccess } from "../../components/general/Notification";
import { hasExpirition } from "../../components/general/general-component/abstruct-component/useExpirition";
const END_POINT = process.env.REACT_APP_BASE_URL;

const get = (arr,type) => {
    return ({
        type: type,
        payload: arr
    })
}
const add = (type) => {
    return ({
        type: type
    })
}
const delelte = (type) => {
    return ({
        type: type
    })
}
const edit= (type) => {
    return ({
        type: type 
    })
}

export const postProjectType = (state,setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        axios.post(`${END_POINT}/api/creative-work-types`, state, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                dispatch(add(types.ADD_PROJECTTYPE));
                dispatch(loadProjectTypes());
                notifysuccess(res.data.message)
                setLoad(false)
            }
        }).catch((err) => {
            setLoad(false)
            notifyError(err.response.data.message)
        })
    }
}

export const loadProjectTypes = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        console.log(END_POINT)
        axios.get(`${END_POINT}/api/creative-work-types`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data,types.GET_PROJECTTYPES));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })
    }
}

export const filterProjectTypes = (name, setLoad) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA")
        setLoad(true);
        const queryParams = [];
        if (name !== '') queryParams.push(`filters[name]=${name}`);
        const finalQuery = queryParams.join('&');
        const apiUrl = `${END_POINT}/api/creative-work-types?${finalQuery}`;
        console.log(apiUrl);
        axios.get(apiUrl, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            setLoad(false);
             dispatch(get(res.data.data,types.GET_PROJECTTYPES));
        }).catch((err) => {
            console.log(err);
            setLoad(false);
        });
    };
};

export const deleteProjectType= (id,setloadDel,setIsDeleted,setIdDeleted) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        setloadDel(true)
        axios.delete(`${END_POINT}/api/creative-work-types/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(delelte(types.DELETE_PROJECTTYPE));
                notifysuccess(res.data.message)
                //dispatch(loadProjectTypes());
                setloadDel(false)
                setIsDeleted('deleted')
                setIdDeleted(id)
            }
        }).catch((err) => {
            setloadDel(false)
            notifyError(err.response.data.message)
        })
    }
}

export const putProjectType = (id,name,type,setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        const formValues = {
            name: name,
            type: type
        };
        axios.put(`${END_POINT}/api/creative-work-types/${id}`,formValues, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                dispatch(edit(types.EDIT_PROJECTTYPE));
                dispatch(loadProjectTypes());
                notifysuccess(res.data.message)
                setLoad(false)
            }
        }).catch((err) => {
            setLoad(false)
            notifyError(err.response.data.message)
        })
    }
}
